import React, { useRef, useState } from "react";
import { Button, Card, Col, Divider, Image, message, Row, Statistic, Typography } from "antd";
// import "../get-started.style.css";
import OtpInput from "../../../shared/components/otp-input";
import moment from "moment";
import Mobile_logo_ar from '../../../assets/imgs/thrivve-logo-ar.svg';
import '../phone-confirmation.style.css';
import { useAppDispatch, useAppSelector } from "../../../shared/hooks/redux";
import { setIsEditPhoneModalOpen, setOtpCode } from "../phone-confirmation.slice";
import EditPhoneModal from "./edit-phone-modal";
import { useTranslation } from "react-i18next";
import { postConfirmOtpCode, postEditLead } from "../phone-confirmation.model";
import { logFireBaseEvent } from "../../../firebase";

function OtpConfirmation() {
    const [otpTimer, setOtpTimer] = useState<any>(moment().add(60, "seconds"));
    const { otpCode, confirming, phoneNumber, editingLead } = useAppSelector(({ PhoneConfirmation }) => PhoneConfirmation);
    const dispatch = useAppDispatch();
    const duration: { current: number } = useRef(60);
    const { t } = useTranslation();
    function onCompleteOtp(otp: any) {
        dispatch(setOtpCode(otp));
    }
    function onSendOtp() {
        const onSuccessCallback = () => {
            message.success(t("New OTP code rescinded successfully"));
        }
        dispatch(postEditLead({ captain_mobile: undefined, onSuccessCallback }));
        duration.current = duration.current * 2;
        setOtpTimer(moment().add(duration.current, "seconds"));
    }
    function handleTimerFinish() {
        setOtpTimer(0);
    }
    function onEditPhone() {
        dispatch(setIsEditPhoneModalOpen(true));
    }
    function submitLeadInfo() {
        const onsuccessCallback = () => {
            logFireBaseEvent({ name: "Apply_Lead_Submitted" });
        }
        dispatch(postConfirmOtpCode({ otp_code: otpCode, onsuccessCallback }));
    }
    return (
        <Row justify={"center"} align={"middle"} style={{ overflow: "hidden" }}>
            <Col lg={0} md={0} sm={24} xs={24} className={"otpConfirmHeaderCol"} >
                <Row justify={"center"}>
                    <Col>
                        <Image src={Mobile_logo_ar} alt="Thrivve logo" preview={false} />
                    </Col>
                    <Col span={24} className="confirm-info-title">
                        <Typography.Title level={3}>{t("Confirm Your Contact Info")}</Typography.Title>
                    </Col>
                </Row>
            </Col>
            <Col span={24}>
                <Card>
                    <Row justify={"center"} gutter={[0, 24]} className="otp">
                        <Col lg={24} sm={0} xs={0} className="CenterText" >
                            <Row align={"middle"} justify={"center"}>
                                <Col>
                                    <Image src={Mobile_logo_ar} alt="Thrivve Logo" preview={false} />
                                </Col>
                                <Col span={24}>
                                    <Divider />
                                </Col>
                            </Row>
                        </Col>
                        <Col span={24} className="CenterText">
                            <Typography.Text strong className="label">الرجاء إدخال رمز التحقق المرسل على الرقم: </Typography.Text>
                            <span>{phoneNumber}</span>
                            <button
                                className="otp-edit-phone-btn"
                                onClick={onEditPhone}
                            >
                                (تعديل)
                            </button>
                        </Col>
                        <Col span={24}>
                            <Row justify={"center"} gutter={[0, 8]}>
                                <Col span={24}>
                                    <Row justify={"center"}>
                                        <Col lg={10} md={15} sm={18} xs={20}>
                                            <OtpInput
                                                inputsNumber={6}
                                                onComplete={onCompleteOtp} justify={"space-between"} gutter={0}
                                            />
                                        </Col>
                                    </Row>
                                </Col>
                                <Col lg={10} md={15} sm={18} xs={20}>
                                    <Row justify={"space-between"} align={"middle"}>
                                        <Col>
                                            <Statistic.Countdown
                                                format={"ss"}
                                                suffix={"ثانية"}
                                                value={otpTimer}
                                                onFinish={handleTimerFinish}
                                                valueStyle={{ fontSize: 16 }}
                                            />
                                        </Col>
                                        <Col>
                                            <Button
                                                className={"send-otp-btn"} type="link"
                                                disabled={!!otpTimer}
                                                onClick={onSendOtp}
                                                loading={editingLead}
                                            >
                                                إعادة إرسال الرمز
                                            </Button>
                                        </Col>
                                    </Row>
                                </Col>
                            </Row>
                        </Col >
                    </Row >
                    <Row justify={"center"} gutter={24}>
                        <Col span={24}><Divider /></Col>
                        <Col span={24}>
                            <Button
                                block
                                type="primary" className={`confirm-otp-btn ${!otpCode ? "disabled" : ""}`}
                                disabled={!otpCode}
                                onClick={submitLeadInfo}
                                loading={confirming}
                            >تأكيد</Button>
                        </Col>
                    </Row>
                    <EditPhoneModal />
                </Card>
            </Col>
        </Row>
    );
}

export default OtpConfirmation;